module.exports = __webpack_public_path__ + "img/tuin_voortuin.3dde00e2.png";